import React from 'react';
import PropTypes from 'prop-types'

const Grid4 = ({ width = "10", height = "10", fill = '#424242' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 0V13H0V0H13ZM11.75 1.25H1.25V11.75H11.75V1.25ZM13 16V29H0V16H13ZM11.75 17.25H1.25V27.75H11.75V17.25ZM29 13V0H16V13H29ZM17.25 1.25H27.75V11.75H17.25V1.25ZM29 16V29H16V16H29ZM27.75 17.25H17.25V27.75H27.75V17.25Z"
      fill={fill}
    />
  </svg>
);

Grid4.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

export default Grid4;
